import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

const RedirectionPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/');
  }, []);
  return (<></>);
}

export default RedirectionPage;